export enum SyncStatus {
  NotRun,
  Syncing,
  Synced,
  Error,
}
